import { MdClose } from 'react-icons/md';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import {
  dateToStringDDMMYYY,
  dateToStringTime,
} from '../../../../commons/date';

// Relatório GERENCIAL das ações do pedido (reformulado 05/07): o gestor precisa
// ver de relance ONDE o pedido ficou parado (barra proporcional ao tempo de
// cada etapa; a mais demorada em vermelho) e ONDE houve RETRABALHO (selo na
// linha em que um status se repetiu).
const ActionsOrderModal = ({ actions }) => {
  // "Tempo processo" da linha = quanto tempo levou DESDE A AÇÃO ANTERIOR até
  // chegar neste status. A barra é proporcional à etapa mais demorada.
  const maxProcessSeconds = Math.max(
    0,
    ...actions.map((item) => item.timeProcess?.total_seconds || 0)
  );

  // Retrabalho: o status desta linha já havia acontecido ANTES (volta no fluxo).
  const isReworkRow = (item) =>
    actions.some(
      (other) =>
        other.id !== item.id &&
        other.order_status === item.order_status &&
        new Date(other.created_at) < new Date(item.created_at)
    );

  const barPercent = (item) => {
    if (!maxProcessSeconds) return 0;
    return Math.round(
      ((item.timeProcess?.total_seconds || 0) / maxProcessSeconds) * 100
    );
  };

  const barColor = (percent) => {
    if (percent >= 80) return '#d11515';
    if (percent >= 40) return '#e67e22';
    return '#a0a0a0';
  };

  // Tempo total do pedido = "tempo desde o início" da ação mais recente.
  const totalTime = actions[0]?.timeStart?.human;

  return (
    <ModalContainer>
      <div className="modal fade" tabIndex="-1" id="modal-view-actions-order">
        <div className="modal-dialog  modal-dialog-centered modal-xl">
          <div className="modal-content ">
            <div className="modal-header">
              <h5 className="modal-title col-11 text-center text-uppercase">
                Ações realizadas
              </h5>
              <MdClose
                id="close"
                size={30}
                data-bs-dismiss="modal"
                type="button"
                onClick={() => {}}
              />
            </div>
            <div className="bg-modal">
              <div className="modal-body">
                <div className="report-header">
                  {totalTime && (
                    <span>
                      Tempo total do pedido: <b>{totalTime}</b>
                    </span>
                  )}
                  <span className="hint">
                    A barra mostra quanto tempo o pedido levou para chegar em
                    cada etapa — a mais demorada em vermelho.
                  </span>
                </div>

                <div className="table-responsive">
                  <table className="table table-hover text-center table-striped">
                    <thead>
                      <tr>
                        <th scope="col" className="text-start">
                          QUANDO
                        </th>
                        <th scope="col" className="text-start">
                          STATUS
                        </th>
                        <th scope="col" className="text-start">
                          USUÁRIO
                        </th>
                        <th scope="col" className="text-start">
                          TEMPO ATÉ ESTA ETAPA
                        </th>
                        <th scope="col" className="text-start">
                          TEMPO TOTAL
                        </th>
                        <th scope="col" className="text-start">
                          OBSERVAÇÕES
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {actions.map((item) => {
                        const percent = barPercent(item);

                        return (
                          <tr key={item.id}>
                            <td className="text-start text-nowrap">
                              {dateToStringDDMMYYY(item.created_at)}{' '}
                              <span className="time">
                                {dateToStringTime(item.created_at)}
                              </span>
                            </td>
                            <td className="text-start text-nowrap">
                              {item.order_status}
                              {isReworkRow(item) && (
                                <span className="rework-badge">RETRABALHO</span>
                              )}
                            </td>
                            <td className="text-start">
                              {item.user_full_name}
                            </td>
                            <td className="text-start process-cell">
                              {item.timeProcess ? (
                                <>
                                  <span
                                    className="duration"
                                    style={{
                                      color:
                                        percent >= 80 ? '#d11515' : '#464646',
                                      fontWeight: percent >= 40 ? 700 : 400,
                                    }}
                                  >
                                    {item.timeProcess.human}
                                  </span>
                                  <div className="bar-track">
                                    <div
                                      className="bar"
                                      style={{
                                        width: `${Math.max(percent, 2)}%`,
                                        backgroundColor: barColor(percent),
                                      }}
                                    />
                                  </div>
                                </>
                              ) : (
                                <span className="duration">—</span>
                              )}
                            </td>
                            <td className="text-start text-nowrap">
                              {item.timeStart?.human || '—'}
                            </td>
                            <td className="text-start note-cell">
                              {item.note}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="row justify-content-end">
                <div className="col-6 col-md-2 m-3">
                  <button
                    type="button"
                    data-bs-dismiss="modal"
                    className="btn btn-outline-secondary btn-block col-12"
                  >
                    Cancelar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ModalContainer>
  );
};

ActionsOrderModal.propTypes = {
  actions: PropTypes.arrayOf(Object).isRequired,
};

export default ActionsOrderModal;

export const ModalContainer = styled.div`
  .bg-modal {
    background-color: #f5f5f5;
    margin: 7px;
  }

  .modal-header {
    border: none;
    background-color: #4f4f4f;
    color: #fff;
    justify-content: center !important;
  }

  .modal-body {
    text-transform: uppercase;
  }

  .report-header {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
    font-size: 13px;
    text-transform: none;

    .hint {
      color: #888;
      font-size: 12px;
    }
  }

  .time {
    color: #888;
    font-size: 12px;
    margin-left: 4px;
  }

  .rework-badge {
    background-color: #e67e22;
    color: #fff;
    font-size: 10px;
    font-weight: 700;
    padding: 1px 8px;
    border-radius: 10px;
    margin-left: 6px;
    letter-spacing: 0.5px;
  }

  .process-cell {
    min-width: 180px;

    .duration {
      text-transform: none;
      font-size: 13px;
    }

    .bar-track {
      margin-top: 3px;
      height: 6px;
      background-color: #e6e6e6;
      border-radius: 3px;
      overflow: hidden;

      .bar {
        height: 100%;
        border-radius: 3px;
      }
    }
  }

  .note-cell {
    text-transform: none;
  }

  .modal-footer {
    justify-content: center !important;
    border: none;
  }

  svg {
    :hover {
      cursor: pointer;
      color: #ffba00;
    }
  }
`;
